import React from "react";
import {
  FaUserPlus,
  FaRunning,
  FaUtensils,
  FaUsers,
  FaTrophy,
} from "react-icons/fa";
import { HiSparkles } from "react-icons/hi2";

const AddOnsCustomization = ({ dynamicAddons = [] }) => {
  const defaultAddOns = [
    {
      id: "additional-participants",
      icon: <FaUserPlus />,
      title: "ADDITIONAL PARTICIPANTS",
      desc: "$20–$30 per extra player beyond included package limit (Small: $20, All-Star: $25, Big League: $30).",
    },
    {
      id: "additional-sport",
      icon: <FaRunning />,
      title: "ADDITIONAL SPORT",
      desc: "Split your 90 minutes across two sports (e.g. 45 min Soccer + 45 min Basketball).",
    },
    {
      id: "food-beverages",
      icon: <FaUtensils />,
      title: "FOOD & BEVERAGES",
      desc: "Piping hot artisan pizza, finger food shareables, and unlimited soda hydration stations.",
    },
    {
      id: "larger-groups",
      icon: <FaUsers />,
      title: "LARGER GROUPS (25+ TO 100+)",
      desc: "Custom arena buyouts, dual court setups, and corporate tournament brackets.",
    },
    {
      id: "special-requests",
      icon: <HiSparkles />,
      title: "SPECIAL REQUESTS",
      desc: "Custom music playlists, tournament refereeing, trophy presentations, or custom party times.",
    },
  ];

  const displayAddons =
    dynamicAddons && dynamicAddons.length > 0
      ? dynamicAddons.map((dyn) => {
          const matching = defaultAddOns.find(
            (a) =>
              a.id === dyn.id ||
              a.title?.toLowerCase() === dyn.title?.toLowerCase()
          );
          return {
            ...dyn,
            icon: matching ? matching.icon : <HiSparkles />,
          };
        })
      : defaultAddOns;

  return (
    <div
      id="addons"
      className="w-full py-20 px-4 md:px-8 lg:px-12 bg-white select-none text-gray-800 border-t border-gray-100"
    >
      <div className="max-w-[1600px] mx-auto flex flex-col items-center">
        {/* Section Heading */}
        <h2 className="text-3xl sm:text-5xl md:text-6xl font-heading font-black text-primaryBtnColor uppercase text-center tracking-tight leading-tight">
          ADD-ONS &amp; CUSTOMIZATION
        </h2>

        {/* Subtitle */}
        <p className="mt-3 text-gray-600 font-subheading text-base sm:text-lg max-w-2xl text-center leading-relaxed">
          Tailor every aspect of your event to match your squad's style.
        </p>

        {/* 5 White Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5 w-full mt-12">
          {displayAddons.map((addon) => (
            <div
              key={addon.id}
              className="bg-white border border-gray-200 hover:border-primaryBtnHoverColor/40 hover:shadow-md rounded-2xl p-5 sm:p-6 transition-all duration-200 flex flex-col justify-between group relative select-none shadow-xs"
            >
              <div>
                {/* Top Row: Icon inside rounded square */}
                <div className="flex items-center justify-between gap-3 mb-5">
                  <div className="w-11 h-11 rounded-xl bg-red-50 border border-primaryBtnHoverColor/20 flex items-center justify-center text-primaryBtnHoverColor text-xl group-hover:scale-110 transition-transform duration-200 shadow-2xs">
                    {addon.icon}
                  </div>
                </div>

                {/* Card Title */}
                <h4 className="font-heading font-extrabold text-sm sm:text-base text-gray-900 uppercase tracking-wider leading-snug">
                  {addon.title}
                </h4>

                {/* Card Description */}
                <p className="text-gray-600 font-subheading text-xs sm:text-sm mt-3 leading-relaxed">
                  {addon.desc}
                </p>
              </div>

              {/* Bottom Feature Tag */}
              <div className="mt-5 pt-3 border-t border-gray-100 flex items-center justify-between text-[11px] font-heading font-bold text-gray-500">
                <span className="uppercase tracking-wider text-primaryBtnHoverColor flex items-center gap-1.5">
                  <HiSparkles className="text-xs" />
                  <span>Custom Add-on</span>
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Informative Note Box */}
        <div className="w-full max-w-4xl mt-12 bg-gray-50 border border-gray-200 rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left shadow-xs">
          <div>
            <div className="flex items-center justify-center sm:justify-start gap-2 text-primaryBtnHoverColor text-xs font-heading font-bold uppercase tracking-wider">
              <HiSparkles />
              <span>FLEXIBLE EVENT CUSTOMIZATION</span>
            </div>
            <h4 className="text-gray-900 font-heading font-bold text-base sm:text-lg mt-1">
              Need custom court times, refereeing, or corporate tournament setups?
            </h4>
            <p className="text-gray-600 font-subheading text-xs mt-0.5">
              All add-ons are customized to your group size and confirmed before booking.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOnsCustomization;
